import Cookies from 'js-cookie'
const languages = require('./supported_languages.json')
export const locales = languages.list
export const defaultLocale = Cookies.get('_al') || languages.default_language
